import styled from "styled-components";

export const InputField = styled.input`
  padding: 0.5rem;
  margin: 0 auto;

  @media only screen and (min-width: 900px) {
    width: 90%;
  }
`;
